import { MicroFrontEnd } from 'properties-ui-common'
import apiConfig from '../../../apiConfig'
import { TgtLogger } from '@measurement/opentelemetry-web'

export const QmsVendorTakeoff = () => {
  return (
    <MicroFrontEnd
      name="QmsVendorTakeoff"
      src={apiConfig.microFrontEnds.QmsVendorTakeoff}
      useErrorBoundary
      logger={TgtLogger}
    />
  )
}

export default QmsVendorTakeoff
